import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Seo } from "../components/Seo";

const NotFound = () => {
  return (
    <>
      <Seo
        title="Page Not Found"
        description="The page you were looking for could not be found. Browse Prime Tenancy Cleaning services or return to the homepage."
        path="/404"
      />
      <section className="min-h-[70vh] flex items-center justify-center bg-navy pt-32 pb-20">
        <div className="container mx-auto px-6 text-center">
          <span className="text-teal font-semibold text-sm uppercase tracking-wider">
            404
          </span>
          <h1 className="font-heading text-5xl md:text-7xl font-bold text-white mt-3 mb-6">
            We can't find that page
          </h1>
          <p className="text-slate-300 text-lg max-w-xl mx-auto mb-10">
            The page you were trying to reach has moved or never existed. Use
            the links below to find what you need.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/">
              <Button className="bg-gold hover:bg-gold-dark text-navy font-semibold px-7 py-6 rounded-xl">
                Back to home
              </Button>
            </Link>
            <Link to="/contact">
              <Button
                variant="outline"
                className="border-white/30 text-white hover:bg-white/10 font-semibold px-7 py-6 rounded-xl"
              >
                Contact us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
